import jwt_decode from 'jwt-decode';

function getUser() {
  const token = localStorage.getItem('auth');

  if (token === null) {
    return null;
  }

  return jwt_decode(token);
}

export { getUser };
